let counter = 0;
/** Locally-unique stable id for new pages / options / pairs / blocks. */
export function genId(prefix: string): string {
  counter += 1;
  return `${prefix}-${Date.now().toString(36)}-${counter.toString(36)}`;
}
